import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import styles from './FBReactionControl.scss';
import Popover from '../../Popover/Popover';
import ReactTooltip from 'react-tooltip';

var FBReactionControl = /*#__PURE__*/function (_Component) {
  _inherits(FBReactionControl, _Component);

  var _super = _createSuper(FBReactionControl);

  function FBReactionControl() {
    var _this;

    _classCallCheck(this, FBReactionControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      popoverOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "reactions", [{
      name: 'Like',
      type: 'LIKE',
      img: 'https://likeabucket.s3.amazonaws.com/vj9ig2je2d_1495727817289.gif'
    }, {
      name: 'Love',
      type: 'LOVE',
      img: 'https://likeabucket.s3.amazonaws.com/e0uiwa0xkd_1495727843710.gif'
    }, {
      name: 'Wow',
      type: 'WOW',
      img: 'https://likeabucket.s3.amazonaws.com/n1ngun1rnp_1495727884751.gif'
    }, {
      name: 'Haha',
      type: 'HAHA',
      img: 'https://likeabucket.s3.amazonaws.com/pyoxt5n3ov_1495727906199.gif'
    }, {
      name: 'Sad',
      type: 'SAD',
      img: 'https://likeabucket.s3.amazonaws.com/g9deh1byq4_1495727925047.gif'
    }, {
      name: 'Angry',
      type: 'ANGRY',
      img: 'https://likeabucket.s3.amazonaws.com/qcbvzqz7wu_1495727945858.gif'
    }]);

    return _this;
  }

  _createClass(FBReactionControl, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          selectedReactionType = _this$props.selectedReactionType,
          handleReaction = _this$props.handleReaction,
          handleClearReaction = _this$props.handleClearReaction;
      var labelClasses = [styles.label];

      if (selectedReactionType) {
        labelClasses.push(styles["labelColor".concat(selectedReactionType)]);
      }

      return /*#__PURE__*/React.createElement(Popover, {
        open: this.state.popoverOpen,
        preferPlace: "above",
        content: /*#__PURE__*/React.createElement("div", {
          onMouseOut: function onMouseOut() {
            _this2.popoverTimeoutHandle = setTimeout(function () {
              _this2.setState({
                popoverOpen: false
              });
            }, 800);
          },
          onMouseOver: function onMouseOver() {
            if (_this2.popoverTimeoutHandle) {
              clearTimeout(_this2.popoverTimeoutHandle);
            }
          },
          className: styles.reactionWrap
        }, this.reactions.map(function (reaction) {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
            onClick: function onClick() {
              handleReaction(reaction.type);

              _this2.setState({
                popoverOpen: false
              });
            },
            "data-tip": true,
            "data-for": "reaction_control_".concat(reaction.type),
            src: reaction.img
          }), /*#__PURE__*/React.createElement(ReactTooltip, {
            id: "reaction_control_".concat(reaction.type),
            effect: "solid"
          }, reaction.name));
        }))
      }, /*#__PURE__*/React.createElement("span", {
        onMouseOver: function onMouseOver() {
          if (!_this2.props.showReactions) {
            _this2.timeoutHandle = setTimeout(function () {
              _this2.setState({
                popoverOpen: true
              });
            }, 500);
          }
        },
        onMouseOut: function onMouseOut() {
          if (!_this2.props.showReactions) {
            if (_this2.timeoutHandle) {
              clearTimeout(_this2.timeoutHandle);
            }
          }
        },
        className: labelClasses.join(' '),
        onClick: function onClick() {
          if (selectedReactionType) {
            handleClearReaction();
          } else {
            handleReaction('LIKE');
          }

          _this2.setState({
            popoverOpen: false
          });
        },
        style: _objectSpread({}, selectedReactionType ? {
          fontWeight: 'bold'
        } : {})
      }, selectedReactionType ? function () {
        var r = _this2.reactions.find(function (r) {
          return r.type === selectedReactionType;
        });

        return r ? r.name : 'Like';
      }() : 'Like'));
    }
  }]);

  return FBReactionControl;
}(Component);

_defineProperty(FBReactionControl, "defaultProps", {
  showReactions: true // Our app does not have permission to do reactions via the API - I don't believe there is even an API to do this yet

});

export { FBReactionControl as default };